module.exports = __webpack_public_path__ + "img/m2g_why_01.54db4d04.png";